import { collection, onSnapshot, query, where, limit } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export function subscribeTriageItems(onData, onError) {
  const rootRef = collection(db, 'rda_triage');
  const qq = query(rootRef, where('status', '==', 'pending_review'), limit(200));
  return onSnapshot(
    qq,
    (snap) => {
      const out = snap.docs.map((d) => ({ id: d.id, ...(d.data() || {}), _ref: d.ref }));
      onData(out);
    },
    (e) => {
      const hasAppId = String(appId || '').trim();
      if (!hasAppId) {
        onError && onError(e);
        return;
      }
      const appRef = collection(db, 'artifacts', hasAppId, 'public', 'data', 'rda_triage');
      const appQq = query(appRef, where('status', '==', 'pending_review'), limit(200));
      onSnapshot(
        appQq,
        (snap2) => {
          const out = snap2.docs.map((d) => ({ id: d.id, ...(d.data() || {}), _ref: d.ref }));
          onData(out);
        },
        (e2) => onError && onError(e2)
      );
    }
  );
}
